"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext, useMemo } from "react";
const SiweContext = createContext({
  siweAdapter: undefined
});
export function SiweProvider(t0) {
  const $ = _c(5);
  const {
    siweAdapter,
    children
  } = t0;
  let t1;
  let t2;
  if ($[0] !== siweAdapter) {
    t2 = {
      siweAdapter
    };
    $[0] = siweAdapter;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  t1 = t2;
  const value = t1;
  let t3;
  if ($[2] !== children || $[3] !== value) {
    t3 = <SiweContext.Provider value={value}>{children}</SiweContext.Provider>;
    $[2] = children;
    $[3] = value;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
export function useSiweAdapter() {
  const {
    siweAdapter
  } = useContext(SiweContext);
  return siweAdapter;
}